var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dv-border-box-13',[_c('div',{staticStyle:{"height":"410px"},attrs:{"id":"myChartOne"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }